module.exports = __webpack_public_path__ + "static/media/home-icon-black.fff83b4f.png";